<nav class="tu-nav-header navbar navbar-expand-lg navbar-light" [attr.aria-label]="'content.site-wide-header' | translate" role="navigation">
  <div class="container d-flex align-items-end">
    <ul class="nav d-flex align-items-end">
      <li class="nav-item">
        <a class="navbar-brand tu-logo-top" href="http://www.transunion.ca/">
          <img [alt]="'content.go-to-the-transunion-home-page' | translate" src="../../assets/images/TU_logo.png">
        </a>
      </li>
      <li class="nav-item">
        <a class="title-link page-title-header" [routerLink]="headerRedirectUrl" [attr.aria-label]="'content.go-to-root-of-tu-direct' | translate">
          {{ 'content.tu-direct' | translate }}
        </a>
      </li >
      @if (showVersion) {
        <li class="nav-item">
          <div class="version col ms-3">
            <div>UI: {{ uiVersion }}</div>
            <div>Admin Services: {{ adminVersion }}</div>
            <div>Reports Services: {{ reportsVersion }}</div>
          </div>
        </li>
      }
    </ul>
    <div>
      <div class="col">
        <div class="header-functions inline-gap-20" [attr.aria-label]="'content.header-functions' | translate" role="region">
          <button class="tu-link lang-selector p-1" (click)="toggleEngFr()">
            <img alt="{{ 'content.canada-flag' | translate }}" src="../../assets/images/CANFlag.png"/>
            {{ 'content.lang-switch-link' | translate }}
          </button>
          @if (isUserPartiallyLoggedIn) {
            <div class="d-inline-block" ngbDropdown>
              <button class="tu-link user-link border-0 p-1" ngbDropdownToggle [attr.aria-label]="'content.show-user-drop-down-menu' | translate:{username: userDisplayName}">
                {{ userDisplayName }}
              </button>
              <div class="header-dropdown-content" [attr.aria-label]="'content.user-drop-down-menu' | translate" ngbDropdownMenu role="region">
                @if (isUserLoggedIn) {
                  <a class="tu-link user-link p-1" ngbDropdownItem [routerLink]="'/edit-profile'">
                    <fa-icon [icon]="faEdit"></fa-icon>
                    {{ 'content.edit-profile' | translate }}
                  </a>
                }
                <button class="tu-link user-link p-1" ngbDropdownItem (click)="logout()">
                  <fa-icon [icon]="faLock"></fa-icon>
                  {{ 'content.logout' | translate }}
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</nav>
